import React, { Component, Fragment } from 'react'
import FooterDesktop from '../components/common/FooterDesktop'
import FooterMobile from '../components/common/FooterMobile'
import NavMenuDesktop from '../components/common/NavMenuDesktop'
import NavMenuMobile from '../components/common/NavMenuMobile'
import Profile from '../components/common/Profile'


class ProfilePage extends Component {


     constructor(props) {
          super(props);
          this.state = {
              profileKey: Date.now(), // Unique key for the Profile component
          };
      }

      updateProfileKey = () => {
          this.setState({ profileKey: Date.now() }); // Update the key to remount Profile component
      };  

     componentDidMount(){
          window.scroll(0,0)
     }

     render() {

          const User = this.props.user;
 
          return (
               <Fragment> 
               <div className="Desktop">
                <NavMenuDesktop /> 
               </div>

               <div className="Mobile">
               <NavMenuMobile />  
               </div>                       
 
               <Profile key={this.state.profileKey} user = {User} updateProfileKey={this.updateProfileKey} />

               
               <div className="Desktop">
               <FooterDesktop/>
               </div>

               <div className="Mobile">
               <FooterMobile/>
               </div>
               
          </Fragment>
          )
     }
}

export default ProfilePage
